angular.module( 'acme.view.application.passes.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesList = {
        name: 'application.passes.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'PassesListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Pass Ranges for Access Control',
          enablePreferences: true
        }
      };

    $stateProvider
      .state(passesList);
});
